/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './findCorrelation.defs.js'
export { main as default } from './findCorrelation.defs.js'
